module.exports = __webpack_public_path__ + "img/ico2.bb13eb79.svg";